import Image, { ImageProps } from "next/image";
import { Box, Heading, HeadingProps } from "../../atoms";
import { styled } from "utils";

const Card = styled(Box, {
  borderRadius: "$3",
  padding: "$4",
  boxShadow: "$cards",
  overflow: "hidden",
  backgroundColor: "$white",
});

const CardTitle: React.FC<HeadingProps> = ({ as = "h3", ...props }) => {
  return <Heading as={as} {...props} />;
};

const StyledCover = styled("div", {
  position: "relative",
  height: 260,
  margin: "calc(-1 * $4)",
  marginBottom: "$3",
});

const StyledImaged = styled(Image, { objectFit: "cover" });

const CardCover: React.FC<ImageProps> = ({ src, alt, priority, ...props }) => {
  return (
    <StyledCover {...props}>
      <StyledImaged src={src} alt={alt} layout="fill" priority={priority} />
    </StyledCover>
  );
};

export { Card, CardTitle, CardCover };
